<div class="w-100 h-100" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="24px">
    <af-dashboard-filter [showOrganizations]="false"
                         [showDateRangePicker]="true"
                         [hasPickerActions]="false"
                         [shouldUseFullMonthSubstraction]="true"
                         [showDate]="false"
                         [hasTime]="false"
                         [showChips]="hasChips"
                         [subtractMonths]="2"
                         [chipsFormControlName]="hasChips ? 'classificationBy' : undefined"
                         [chips]="hasChips ? [ClassificationType.FRAUD_TYPE, ClassificationType.TRANSACTION_TYPE] : []"
                         (dataChangeListener)="filter($event)"/>
    @if (hasMlLabel) {
        <div class="t3">{{ 'i18n_af_labelClassificationMatrixMlLabel' | translate }}</div>
    }
    <af-classification-group-panel [classificationGroupPanelData]="classificationGroupPanelData"
                                   (clickListener)="openDetails.emit($event)"/>
</div>
